import { render } from "./activate.vue?vue&type=template&id=1f5d0fde"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"

import "./activate.vue?vue&type=style&index=0&id=1f5d0fde&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__